<script setup lang="ts">
import WochenplanEmailAnpassen from "@/features/disposition/actions/WochenplanEmailAnpassen.vue";
import SettingsBlock from "../../../components/SettingsBlock.vue";
</script>

<template>
  <div class="p-5 px-6 bg-gray-500 print:p-0 print:bg-white">
    <div class="grid grid-cols-3 gap-5">
      <SettingsBlock title="Disposition">
        <WochenplanEmailAnpassen />
      </SettingsBlock>
      <SettingsBlock title="Begleitfahrt Typen">
        <router-link :to="{ name: 'sonstiges-begleitfahrt-typen' }">
          Anpassen
        </router-link>
      </SettingsBlock>
    </div>
  </div>
</template>
